import styled from 'styled-components'
import { themeGet } from 'styled-system'
import MarkCompleteButtonIcon from 'components/MarkCompleteButtonIcon'

export const SimpleMarkCompleteButton = styled.button`
  height: 2.688rem;
  min-width: 9.375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  border: none;
  font-family: ${themeGet('fonts.moldeMedium16.fontFamily', 'Molde-medium')};
  font-size: ${themeGet('fonts.moldeMedium16.fontSize', '1rem')};
  line-height: ${themeGet('fonts.moldeMedium16.lineHeight', '1.063rem')};
  cursor: ${props => (props.isComplete ? 'default' : 'pointer')};
  background-color: ${props => {
    if (props.isComplete) {
      return themeGet('colors.paleGray', '#EEF0F2')
    }
    return themeGet('colors.buttons.primary.bgActive')
  }};
  color: ${props => {
    if (props.isComplete) {
      return themeGet('individualResource.markCompleteButton.color')
    }
    return themeGet('colors.buttons.primary.titleActive')
  }};
  opacity: ${props => (props.disabled && !props.isComplete ? 0.6 : 1)};

  &:hover {
    background-color: ${props => {
      if (props.isComplete) {
        return themeGet('colors.paleGray', '#EEF0F2')
      }
      return themeGet('individualResource.activityDetails.button.hover.color')
    }};
    color: ${props => {
      if (props.isComplete) {
        return themeGet('individualResource.markCompleteButton.color')
      }
      return themeGet('colors.buttons.primary.titleHover')
    }};
  }

  &:disabled {
    cursor: not-allowed;
  }
  ${themeGet('breakpoints.tabletLarge')} {
    margin-bottom: 1.25rem;
  }
`

export const MarkCompleteIconWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StyledMarkCompleteButtonIcon = styled(MarkCompleteButtonIcon)`
  height: 1rem;
  width: 1rem;
  display: block;
  vertical-align: middle;
`

export const ThemedMarkCompleteButtonIcon = styled(
  MarkCompleteButtonIcon,
).attrs({
  fillColor: props =>
    themeGet('individualResource.markCompleteButton.color', '#555555')(props),
})`
  height: 1rem;
  width: 1rem;
  display: block;
  vertical-align: middle;
  margin-bottom: 0.1rem;
`
